import "./index.css";
import { connect } from "react-redux";
import NotFoundImg from "../../assets/images/notFound.gif";
import { useNavigate } from "react-router-dom";

function NotFound(props) {
  const navigate = useNavigate();

  return (
    <div className="notFoundContainer">
      <img
        className="notFoundImage"
        src={NotFoundImg}
        alt="Access Denied"
      ></img>
      <button
        className="inMainBtn"
        onClick={() => {
          navigate(`/`, {
            replace: true,
          });
        }}
      >
        На главную
      </button>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(NotFound);
